import React, { PropTypes } from 'react';
import Checkbox from 'material-ui/Checkbox';

export class InputCheckbox extends React.Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    labelStyle: PropTypes.object,
    value: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired
  };

  render() {
    let { value, onChange, ...rest }  = this.props;

    return (
      <Checkbox
        checked={value}
        onCheck={onChange}
        {...rest}
      />
    );
  }
}

export default InputCheckbox;





// WEBPACK FOOTER //
// ./src/components/form/InputCheckbox.js